var LeadsCalls = (function () {
  'use strict';

  //Basic Config
  var config = {
  };

  return {
    //General data
    conf: config,

    //Init function
    init: function (options) {
      
      //Extends basic config with options
      $.extend( config, options );

    }
  };
 
})();